import { AriaProps, DOMProps, LinkDOMProps } from '../types';

export const ariaPropNames: Record<keyof AriaProps, boolean> = {
  'aria-controls': true,
  'aria-describedby': true,
  'aria-details': true,
  'aria-errormessage': true,
  'aria-expanded': true,
  'aria-haspopup': true,
  'aria-hidden': true,
  'aria-invalid': true,
  'aria-label': true,
  'aria-labelledby': true,
  'aria-level': true,
  'aria-checked': true,
  'aria-valuenow': true,
  'aria-valuetext': true,
  'aria-valuemin': true,
  'aria-valuemax': true,
  'aria-orientation': true,
};

export type AriaPropKeys = keyof typeof ariaPropNames;

export const domPropNames: Record<keyof DOMProps, boolean> = {
  id: true,
  role: true,
  tabIndex: true,
  onMouseEnter: true,
  onMouseLeave: true,
  onMouseDown: true,
  onMouseUp: true,
};

export type DOMPropKeys = keyof typeof domPropNames;
export const DOMPropNames = new Set(Object.keys(domPropNames));

export const linkPropNames: Record<keyof LinkDOMProps, boolean> = {
  download: true,
  href: true,
  ping: true,
  referrerPolicy: true,
  rel: true,
  target: true,
};

export type LinkPropKeys = keyof typeof linkPropNames;
